<template>
  <div class="container-fluid">
    <how-it-works-banner/>
    <the-basics v-bind="inViewportProps"/>
    <PlansForEveryBudget class="row"/>
    <renting-made-easy-section
      :show-get-started="true"
      variant="origami"/>
    <questions-section v-bind="inViewportProps"/>
    <stylish-safe
      v-bind="inViewportProps"/>
    <comparison-table
      v-bind="inViewportProps"/>
    <membership-perks
      v-bind="inViewportProps"/>
    <WhatMembersSay class="mb-xxl"/>
    <plans-callout
      v-bind="inViewportProps"
      variant="start-quiz"/>
    <email-capture-section
      variant="white"
      class="mb-sm"/>
  </div>
</template>

<script>
import ComparisonTable from '@/homepage/components/howItWorks/ComparisonTable.vue'
import HowItWorksBanner from '@/homepage/components/howItWorks/HowItWorksBanner.vue'
import MembershipPerks from '@/homepage/components/howItWorks/MembershipPerks.vue'
import PlansCallout from '@/homepage/components/sections/PlansCallout.vue'
import QuestionsSection from '@/homepage/components/howItWorks/QuestionsSection.vue'
import RentingMadeEasySection from '@/homepage/components/sections/RentingMadeEasySection.vue'
import EmailCaptureSection from '@/homepage/components/sections/EmailCaptureSection.vue'
import StylishSafe from '@/homepage/components/howItWorks/StylishSafe.vue'
import TheBasics from '@/homepage/components/howItWorks/TheBasics.vue'
import useAnalytics from '@shared/composables/analytics.js'
import PlansForEveryBudget from '@/homepage/components/sections/PlansForEveryBudget.vue'
import WhatMembersSay from '@/homepage/components/sections/WhatMembersSay.vue'

export default {
  components: {
    ComparisonTable,
    EmailCaptureSection,
    HowItWorksBanner,
    MembershipPerks,
    PlansCallout,
    QuestionsSection,
    RentingMadeEasySection,
    StylishSafe,
    TheBasics,
    PlansForEveryBudget,
    WhatMembersSay
  },
  setup () {
    const { trackPageView } = useAnalytics()
    return {
      trackPageView,
    }
  },
  data () {
    return {
      inViewportProps: {
        'in-viewport-root-margin': '20% 0%',
        'in-viewport-once': true
      }
    }
  },
  activated () {
    this.trackPageView('How It Works Page')
  }
}
</script>